import { Component, ReactNode } from "react";
import { Link } from "easy-page-router/react";

import { handleError } from "../services/api";
import { Dictionary, useLang } from "../services/lang";

type ErrorBoundaryProps = {
  children: ReactNode,
};

type ErrorBoundaryState = {
  hasError: boolean,
}

export default function ErrorBoundary({ children }: ErrorBoundaryProps) {
  const { dict } = useLang();

  return <ErrorCatcher dict={dict}>{children}</ErrorCatcher>;
}

class ErrorCatcher extends Component<ErrorBoundaryProps & { dict: Dictionary }, ErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      const { title, apology, action, info } = this.props.dict.errorBoundary;

      return <div className="error-boundary">
        <h1>{title}</h1>
        <p className="error">{apology}</p>
        <p>
          {action[0]} <a onClick={() => window.location.reload()}>{action[1]}</a> {action[2]} <Link href="/" onClick={() => this.setState({ hasError: false })}>{action[3]}</Link>{action[4]}
        </p>
        <p className="info">{info}</p>
      </div>;
    }

    return this.props.children;
  }
}